var React = require('react');
var ReactDom = require('react-dom');

// import SearchComponent from 'debtwire-search-component'
import Header from '@mergermarket/debtwire-react-header';
//import PersonaliseMenu from 'debtwire-personalisation-component'
//import UserMenu from 'debtwire-user-menu-component'

function renderHeader() {
  var headerChildren = [
    //    window.searchProps.staticView !== 'errorController'
    //  ? <SearchComponent key='search' {...window.searchProps} />
    //: null,
    //<SearchComponent key='search' {...window.searchProps} />,
    //<PersonaliseMenu {...window.personaliseMenuProps} />,
    //<UserMenu {...window.userMenuProps} />
  ].filter(Boolean);
  var headerProps = {
    entitlements: window.entitlements,
    subscriptionTags: window.subscriptionTags,
    env: "local",
    //window.env,
    guid: window.guid,
    activeRoute: 'https://www.xtractresearch.com/',
    actionItems: headerChildren,
    dwDomain: window.dwDomain,
    userMenuProps: {
      username: "John Doe",
      contactList: [{
        name: "Email",
        email: "support@acuris.com"
      }, {
        name: "Americas",
        email: "support@acuris.com",
        telephoneNumber: "+1 212 686 5374"
      }, {
        name: "EMEA",
        telephoneNumber: "+1 212 686 5374"
      }, {
        name: "Another",
        email: "support@acuris.com",
        telephoneNumber: "+1 212 686 5374"
      }],
      alertEditionLinks: [{
        name: "Asia",
        link: "asia.debtwire.com"
      }, {
        name: "Americas",
        link: "us.debtwire.com"
      }, {
        name: "Latam",
        link: "latam.debtwire.com"
      }],
      alertLink: "http://xtractresearch.com",
      subscriptions: ["Americas", "EMEA", "Asia", "Australasia"],
      logout: {
        link: "/logout",
        onClick: function onClick() {
          return;
        }
      }
    }
  };
  ReactDom.hydrate(/*#__PURE__*/React.createElement(Header, headerProps), document.getElementById('debtwire-header'));
}
renderHeader();